import { createServerFn } from "@tanstack/solid-start";
import { z } from "zod";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const DepreciationOverviewInputSchema = z.object({
  businessId: z.string().trim().min(1),
});

export const getDepreciationOverview = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => DepreciationOverviewInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("depreciationOverview.get", async () => {
      const { getDepreciationOverviewForUser } =
        await import("./depreciation-overview.server");
      return getDepreciationOverviewForUser(context.user.id, data.businessId);
    });
  });
